<template>
<div class="goodsList_ui">
    <div class="goodsList2">
        <van-cell v-for="(item,i) in goodsListData" :key="i" class="goods-box">
            <div class="box" v-if="goodsListData.length>0&&(i<number||number==-1)" @click="goGoodsDetail(item,i)">
                <div class="img-box">
                    <div class="img-box-content" :class="{'img-box-square':isSquarePic=='T'}">
                        <div class="label" v-if="item.goodsCity&&item.goodsCity!=''">
                            {{item.goodsCity|keyFilter}}
                        </div>
                        <img class="img" v-if="isSquarePic!='T'" v-lazy="item.logo+'?imageView2/1/w/336/h/224/q80/format/webp&x-oss-process=image/resize,m_fill,w_336,h_224'" />
                        <img class="img" v-else v-lazy="item.logo+'?imageView2/1/w/336/h/336/q80/format/webp&x-oss-process=image/resize,m_fill,w_336,h_336'" />
                        <div class="hotelName" v-if="item.supplierName&&item.supplierName!=''&&showListHotelName!='F'&&hideHotelInfo!='T'">
                            <b>{{item.supplierName}}</b>
                        </div>
                        <div class="hotelName" v-else-if="item.hotelName&&item.hotelName!=''&&showListHotelName!='F'&&hideHotelInfo!='T'">
                            <b>{{item.hotelName}}</b>
                        </div>
                    </div>

                </div>

                <div class="goods-content-common">
                    <div class="goods-name">{{item.name}}</div>
                    <div class="goods-price-credit" v-if="item.price>0&&item.credit>0">
                        <div class="price-box">
                            <i class="rmb">¥</i>
                            <div class="price">
                                {{item.price}}
                            </div>
                            <div class="qi" v-if="item.skuFlag">起</div>
                            <div class="proposedPrice" v-if="item.proposedPrice>0">
                                ¥{{item.proposedPrice}}
                            </div>
                        </div>
                        <div class="credit-box">
                            +{{item.credit}}{{creditName}}
                        </div>
                    </div>
                    <div class="goods-price" v-else-if="item.price>0">
                        <div class="price-box">
                            <i class="rmb">¥</i>
                            <div class="price">
                                {{item.price}}
                            </div>
                            <div class="qi" v-if="item.skuFlag">起</div>
                        </div>
                        <div class="proposedPrice" v-if="item.proposedPrice>0">
                            ¥{{item.proposedPrice}}
                        </div>
                    </div>
                    <div class="goods-credit" v-else-if="item.credit>0">
                        <div class="credit-box">
                            <div class="credit">{{item.credit}}</div>
                            <div class="credit-name">{{creditName}}
                                <div class="qi" v-if="item.skuFlag">起</div>
                            </div>

                        </div>
                        <div class="proposedPrice" v-if="item.proposedPrice>0">
                            ¥{{item.proposedPrice}}
                        </div>
                    </div>
                    <div class="goods-free" v-else-if="item.credit<=0&&item.price<=0">
                        <div class="free-box">
                            免费
                        </div>
                        <div class="proposedPrice" v-if="item.proposedPrice>0">
                            ¥{{item.proposedPrice}}
                        </div>
                    </div>
                    <div class="btn" v-if="isBtn=='T'">
                        <img src="https://xcx.ihotel.cn/mall/images/buy-btn.png" />
                    </div>
                </div>
                <div class="no-stock" v-if="item.stock!=undefined&&item.stock<=0"><img src="https://xcx.ihotel.cn/mall-chain/no-stock.png"></img></div>
            </div>
        </van-cell>
    </div>
</div>
</template>

<script>
import price from "@/components/price";
import gcTrack from "@/utils/gcTrack";
import {
    getStorage
} from '@/utils/wxuser';
export default {
    data() {
        return {
            creditName: getStorage('creditName') || '积分',
            isSquarePic: getStorage('isSquarePic') || 'F',
            showListHotelName: getStorage('showListHotelName') || 'T',
        };
    },

    props: {
        goodsListData: {
            type: Array,
        },
        goods: {
            type: Object,
        },
        //有无立即购买按钮
        isBtn: {
            type: String,
            default () {
                return "F";
            },
        },
        goodsType: {
            type: String,
            default () {
                return "";
            },
        },

        totalRows: {
            type: Number,
            default () {
                return 0;
            },
        },
        //有无图片斜切
        isItalic: {
            type: String,
            default () {
                return "F";
            },
        },
        number: {
            type: Number,
            default () {
                return -1;
            },
        },
        name: {
            type: String,
            default () {
                return '';
            },
        },
    },
    filters: {
        keyFilter(val) {
            return val.split(',')[0]
        },
        wordLimit(val) {
            return val.substring(0, 4);
        },
    },
    methods: {
        goGroup(goods) {
            this.$router.push({
                path: "/goodsDetail",
                query: {
                    id: goods.id,
                    productType: "group",
                },
            });
        },
        goFlashGoods(item, i) {
            var data = {
                banner_belong_area: '限时抢购',
                banner_type: '商品',
                banner_name: item.goodsName,
                banner_id: item.id,
                banner_rank: i + 1
            }
            gcTrack.track("SC_HomeOoperationClick", data)
            this.$router.push({
                path: "/goodsDetail",
                query: {
                    id: item.id,
                    productType: "flash",
                    flashTimeSlotRelitionId: item.relationId,
                },
            });
        },
        goGoodsDetail(item, i) {
            if (this.goodsType == "group") {
                this.goGroup(item);
            } else if (this.goodsType == "flash") {
                this.goFlashGoods(item, i)
            } else if (this.goodsType == "firstOrder") {
                this.$router.push({
                    path: "/goodsDetail",
                    query: {
                        id: item.id,
                        goodsId: item.goodsId,
                        productType: 'firstOrder'
                    },
                });
            } else {
                var id = item.id || item.goodsId;
                if (this.goodsType == 'hot') {
                    var data = {
                        banner_belong_area: '热门推荐',
                        banner_type: '商品',
                        banner_name: item.name,
                        banner_id: id,
                        banner_rank: i + 1
                    }
                    gcTrack.track("SC_HomeOoperationClick", data)
                }
                if (this.name != '') {
                    var data = {
                        key_word: this.$route.query.name,
                        key_word_type: '用户输入',
                        position_number: i,
                        search_result_number: this.totalRows * 1,
                        commodity_id: item.id,
                        commodity_name: item.name
                    }
                    gcTrack.track("SC_SearchResultClick", data)
                }
                this.$gc.track({
                    behaviorType: 7,
                    goodsId: id,
                    goodsName: item.name
                });

                this.$router.push({
                    path: "/goodsDetail",
                    query: {
                        id: id,
                    },
                });
            }
        },
    },
    components: {
        price,
    },
    mounted() {},
    created() {},
};
</script>

<style lang="less" scoped>
@import url("~@/styles/base.less");
@import url("~@/styles/mixin.less");

.goodsList_ui {
     .qi {
            display: inline;
            font-size: @price-font-size;
            color: @color-price;
        }

    .goodsList {
        display: flex;

        padding: 0 0.266667rem;
        white-space: nowrap;
        overflow-x: scroll;

       
        &.firstMarginTop {
            margin-top: 0.213333rem;
        }

        .box {
            position: relative;
            width: 4.106667rem;
            margin-right: 0.373333rem;
            padding: 0 0 0.32rem 0;
            background: #fff;
            display: inline-block;
            border-radius: 0.213333rem;
            margin-top: 0.266667rem;
            box-sizing: border-box;

            .img-box {
                position: relative;

                .img-box-content {
                    width: 100%;
                    overflow: hidden;
                    border: 2px solid #fff;
                    height: 2.986667rem;
                    border-radius: 0.213333rem;
                    position: relative;

                    .label {
                        position: absolute;
                        z-index: 2;
                        color: #fff;
                        height: 0.64rem;
                        line-height: 0.64rem;
                        text-align: center;
                        padding: 0 0.266667rem;

                        &::after {
                            content: "";
                            position: absolute;
                            left: 0;
                            top: 0;
                            z-index: -1;
                            width: 100%;
                            height: 100%;
                            background: @color-theme;
                            opacity: 0.6;
                            border-radius: 0.213333rem 0.213333rem 0.213333rem 0px;
                        }

                        span {
                            min-width: 1rem;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            padding-left: 0.2rem;
                            height: 0.64rem;
                            line-height: 0.64rem;
                            white-space: nowrap;
                            box-sizing: border-box;
                            overflow: hidden;
                            text-align: center;
                        }
                    }

                    .hotelName {
                        position: absolute;
                        bottom: 0;
                        left: 50%;
                        width: 86%;
                        margin-left: -43%;
                        height: 0.47988rem;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        white-space: nowrap;

                        b {
                            position: absolute;
                            width: 100%;
                            height: 0.47988rem;
                            z-index: 2;
                            font-size: 10px;
                            color: #fff;
                            display: -webkit-box;
                            -webkit-box-orient: vertical;
                            -webkit-line-clamp: 1;
                            white-space: normal;
                            line-height: 0.47988rem;
                            text-align: center;
                            padding: 0 0.266667rem;
                        }

                        &:after {
                            content: "";
                            position: absolute;
                            bottom: 0;
                            z-index: 1;
                            left: 50%;
                            margin-left: -41.5%;
                            width: 83%;
                            background: @color-theme;
                            opacity: 0.6;
                            height: 0.47988rem;
                            box-sizing: border-box;
                            border-radius: 0.21328rem 0.21328rem 0 0;
                            transform: perspective(0.2666rem) scale(1.1, 1.3) rotateX(5deg);
                        }
                    }

                    .img {
                        width: 100%;
                        height: 100%;
                        border-radius: 0.213333rem;
                        // border-radius: 0.32rem;
                    }
                }

                .bg {
                    width: 100%;
                    height: 100%;
                    position: absolute;
                    left: 0;
                    top: 0;
                }
            }

            .goods-content-common {
                padding: 0 0.266667rem;
                // height: 3.173333rem;
                // text-align: center;

                .goods-name {
                    margin: 0.133333rem 0;
                    font-weight: bold;
                    font-size: 15px;
                    text-align: left;
                    line-height: 0.64rem;
                    height: 1.28rem;
                    display: -webkit-box;
                    -webkit-box-orient: vertical;
                    -webkit-line-clamp: 2;
                    white-space: normal;
                    overflow: hidden;
                    color: #333333;
                }

                .desc {
                    font-size: 12px;
                    color: #333333;
                    height: 0.96rem;
                    width: 100%;
                    text-align: left;
                    white-space: normal;
                    line-height: 0.48rem;
                    display: -webkit-box;
                    -webkit-box-orient: vertical;
                    -webkit-line-clamp: 2;
                    overflow: hidden;

                    &.center {
                        text-align: center;
                    }
                }

                .goods-price {}

                .btn {
                    display: flex;
                    justify-content: center;
                    margin-top: 0.133333rem;

                    img {
                        width: 2.533333rem;
                        height: 0.48rem;
                    }
                }
            }

            .goods-content {
                padding: 0 0.213333rem;
                // height: 3.173333rem;
                text-align: center;

                .goods-name {
                    font-weight: bold;
                    font-size: 15px;
                    text-align: left;
                    height: 0.8rem;
                    line-height: 0.8rem;

                    overflow: hidden;
                    color: #333333;
                }

                .desc {
                    font-size: 12px;
                    color: #333333;
                    height: 0.96rem;
                    width: 100%;
                    text-align: left;
                    white-space: normal;
                    line-height: 0.48rem;
                    display: -webkit-box;
                    -webkit-box-orient: vertical;
                    -webkit-line-clamp: 2;
                    overflow: hidden;

                    &.center {
                        text-align: center;
                    }
                }

                .goods-price {
                    display: flex;
                    justify-content: center;
                }

                .btn {
                    display: flex;
                    justify-content: center;
                    margin-top: 0.133333rem;

                    img {
                        width: 2.533333rem;
                        height: 0.48rem;
                    }
                }
            }

            .no-stock {
                border-radius: 0.213333rem;
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
                background: rgba(255, 255, 255, 0.8);
                z-index: 99;

                img {
                    position: absolute;
                    left: 50%;
                    top: 50%;
                    width: 2.213333rem;
                    height: 1.253333rem;
                    transform: translate(-50%, -50%);
                }
            }
        }
    }

    .goodsList2 {
        display: flex;
        overflow-y: hidden;
        white-space: nowrap;
        overflow-x: scroll;
        padding: 0 0.4rem;

        .goods-box {
            margin-top: 0.4rem;
        }

        &.firstMarginTop {
            margin-top: 0.213333rem;
        }

        .box {
            position: relative;
            width: 4.133333rem;
            margin-right: 0.373333rem;
            background: #fff;
            overflow: hidden;
            display: inline-block;
            border-radius: 0.106667rem;
            height: 100%;
            box-sizing: border-box;
            box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.06);

            .img-box {
                position: relative;

                .img-box-content {
                    width: 100%;
                    overflow: hidden;
                    height: 2.7555rem;
                    position: relative;

                    &.img-box-square {
                        height: 4.133333rem;
                    }

                    .label {
                        position: absolute;
                        z-index: 2;
                        color: #fff;
                        text-align: center;
                        border-radius: 3px 3px 11px 0px;
                        padding: 0.16rem 0.266667rem 0.16rem 0.16rem;
                        background: @label-color;
                    }

                    .img {
                        width: 100%;
                        height: 100%;

                        // border-radius: 0.32rem;
                    }

                    .hotelName {
                        position: absolute;
                        bottom: 0;
                        left: 50%;
                        width: 86%;
                        margin-left: -43%;
                        height: 0.47988rem;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        white-space: nowrap;

                        b {
                            position: absolute;
                            width: 100%;
                            height: 0.47988rem;
                            z-index: 2;
                            font-size: 10px;
                            color: #fff;
                            display: -webkit-box;
                            -webkit-box-orient: vertical;
                            -webkit-line-clamp: 1;
                            white-space: normal;
                            line-height: 0.47988rem;
                            text-align: center;
                            padding: 0 0.266667rem;
                        }

                        &:after {
                            content: "";
                            position: absolute;
                            bottom: 0;
                            z-index: 1;
                            left: 50%;
                            margin-left: -41.5%;
                            width: 83%;
                            background: @color-theme;
                            opacity: 0.6;
                            height: 0.47988rem;
                            box-sizing: border-box;
                            border-radius: 0.21328rem 0.21328rem 0 0;
                            transform: perspective(0.2666rem) scale(1.1, 1.3) rotateX(5deg);
                        }
                    }
                }

                .bg {
                    width: 100%;
                    height: 100%;
                    position: absolute;
                    left: 0;
                    top: 0;
                }
            }

            .goods-content-common {
                padding: 0.213333rem 0.266667rem 0.266667rem;

                .goods-name {
                    font-size: 14px;
                    color: #333333;
                    font-family: PingFangSC-Regular;
                    text-align: left;
                    line-height: 0.533333rem;
                    height: 1.066667rem;
                    display: -webkit-box;
                    -webkit-box-orient: vertical;
                    -webkit-line-clamp: 2;
                    white-space: normal;
                    overflow: hidden;
                    color: #333333;
                }

                .goods-free {
                    line-height: 1.4;

                    .free-box {
                        font-family: PingFangTC-Regular;
                        font-size: 19px;
                        color: @color-price;
                    }

                    .proposedPrice {
                        margin-top: 0.133333rem;
                        font-size: 12px;
                        color: #888888;
                        font-family: PingFangSC-Regular;
                        text-decoration: line-through;
                    }
                }

                .goods-price {
                    line-height: 1.4;

                    .price-box {
                        .rmb {
                            font-family: @price-font-family;
                            font-size: 16px;
                            color: @color-price;
                            display: inline;
                        }

                        .price {
                            display: inline;
                            font-family: @price-font-family;
                            font-size: @price-font-size-big;
                            color: @color-price;
                        }
                    }

                    .proposedPrice {
                        margin-top: 0.133333rem;
                        font-size: 12px;
                        color: #888888;
                        font-family: PingFangSC-Regular;
                        text-decoration: line-through;
                    }
                }

                .goods-credit {
                    line-height: 1.4;

                    .credit-box {
                        .credit {
                            display: inline;
                            font-family: @price-font-family;
                            font-size: @price-font-size-big;
                            color: @color-price;
                        }

                        .credit-name {
                            display: inline;
                            font-size: 12px;
                            color: @color-price;
                        }
                    }

                    .proposedPrice {
                        margin-top: 0.133333rem;
                        font-size: 12px;
                        color: #888888;
                        font-family: PingFangSC-Regular;
                        text-decoration: line-through;
                    }
                }

                .goods-price-credit {
                    line-height: 1.4;

                    .price-box {
                        .rmb {
                            font-family: @price-font-family;
                            font-size: 16px;
                            color: @color-price;
                            display: inline;
                        }

                        .price {
                            display: inline;
                            font-family: @price-font-family;
                            font-size: @price-font-size-big;
                            color: @color-price;
                        }

                        .proposedPrice {
                            display: inline;
                            font-size: 12px;
                            color: #888888;
                            font-family: PingFangSC-Regular;
                            text-decoration: line-through;
                        }
                    }

                    .credit-box {
                        margin-top: 0.133333rem;
                        font-size: 12px;
                        color: @color-credit;
                    }
                }

                .desc {
                    font-size: 12px;
                    color: #333333;
                    height: 0.96rem;
                    width: 100%;
                    text-align: left;
                    white-space: normal;
                    line-height: 0.48rem;
                    display: -webkit-box;
                    -webkit-box-orient: vertical;
                    -webkit-line-clamp: 2;
                    overflow: hidden;

                    &.center {
                        text-align: center;
                    }
                }

                .btn {
                    display: flex;
                    justify-content: center;
                    margin-top: 0.133333rem;

                    img {
                        width: 2.533333rem;
                        height: 0.48rem;
                    }
                }
            }

            .goods-content {
                padding: 0 0.213333rem;
                // height: 3.173333rem;
                text-align: center;

                .goods-name {
                    font-weight: bold;
                    font-size: 15px;
                    text-align: left;
                    height: 0.8rem;
                    line-height: 0.8rem;

                    overflow: hidden;
                    color: #333333;
                }

                .desc {
                    font-size: 12px;
                    color: #333333;
                    height: 0.96rem;
                    width: 100%;
                    text-align: left;
                    white-space: normal;
                    line-height: 0.48rem;
                    display: -webkit-box;
                    -webkit-box-orient: vertical;
                    -webkit-line-clamp: 2;
                    overflow: hidden;

                    &.center {
                        text-align: center;
                    }
                }

                .goods-price {
                    display: flex;
                    justify-content: center;
                }

                .btn {
                    display: flex;
                    justify-content: center;
                    margin-top: 0.133333rem;

                    img {
                        width: 2.533333rem;
                        height: 0.48rem;
                    }
                }
            }

            .no-stock {
                border-radius: 0.106667rem;
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
                background: rgba(255, 255, 255, 0.8);
                z-index: 99;

                img {
                    position: absolute;
                    left: 50%;
                    top: 50%;
                    width: 2.213333rem;
                    height: 1.253333rem;
                    transform: translate(-50%, -50%);
                }
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/goodsListSmall.vue